import { DataSource } from '@angular/cdk/collections';
import { Commodity } from '../../../models/commodity';
import { Observable } from 'rxjs';

export class CommoditiesData implements DataSource<Commodity> {

    constructor(private source$: Observable<Commodity[]>) {
    }

    connect(collectionViewer: any): Observable<Commodity[]> {
        return this.source$;
    }

    disconnect(collectionViewer: any): void {
    }
}
